import React from 'react';
import { useEscapeKey } from '../hooks/useEscapeKey';

const PcgsApiKeyModal = ({ isOpen, onClose, onGoToProfile }) => {
  useEscapeKey(onClose, isOpen);
  if (!isOpen) return null;

  const handleGoToPcgs = () => {
    window.open('https://www.pcgs.com/publicapi/documentation', '_blank');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h2 className="text-xl font-bold mb-4">PCGS API Key Required</h2>
        
        <div className="mb-6">
          <p className="mb-4">
            To use PCGS functionality in NumisNavigator, you'll need to add your PCGS API key.
          </p>
          
          <ol className="list-decimal list-inside space-y-2 mb-4">
            <li>Login to PCGS and then go to <button 
                onClick={handleGoToPcgs}
                className="text-blue-600 hover:text-blue-800 underline"
              >
                their API page
              </button>
            </li>
            <li>Click "Generate Token"</li>
            <li>Add the key to your NumisNavigator profile</li>
          </ol>

          <p className="text-sm text-gray-600">
            Your API key enables secure communication with PCGS services for submissions and certification verification.
          </p>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
          >
            Later
          </button>
          <button
            onClick={onGoToProfile}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Go to Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default PcgsApiKeyModal;
